"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.svgMDRender = void 0;
const lit_element_1 = require("lit-element");
const svgMDRender = (path) => lit_element_1.svg `<svg style="width:20px;height:20px" viewbox="0 0 24 24">
    <path fill="currentColor" d="${path}" />
</svg>`;
exports.svgMDRender = svgMDRender;
